/* "Read more" under the teaser, and the teaser itself (sections/main-product.liquid, title block).
   It opens the Product Details accordion, closes the other accordions and scrolls to it.
   The click listener is on the document, because a variant change replaces the product info. */
(function () {
  if (window.productDetailsReadMore) return;
  window.productDetailsReadMore = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-product-details-link]');
    if (!link) return;

    // The link has the target in href; the teaser has it in data-product-details-link
    const hash = link.getAttribute('href') || link.dataset.productDetailsLink;
    const target = hash && document.getElementById(hash.slice(1));
    const details = target && target.querySelector('details');
    if (!details) return;

    event.preventDefault();
    const root = target.closest('.product_custom') || document;
    root.querySelectorAll('.Colleb_box details[open]').forEach((other) => {
      if (other !== details) other.open = false;
    });
    details.open = true;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });
})();
